import Component from '../abstracts/Component';
import TrackingComponent from './TrackingComponent';
import WishlistLogic from "../logics/WishlistLogic";

export default class CarouselComponent extends Component {
  get SELECTORS() {
    return {
      itemsContainer: '.carousel__items',
      wishlistButton: "[data-js-wishlist]",
      nextArrow: '.arrow-next',
      prevArrow: '.arrow-prev',
    };
  }

  get COMPONENTNAME() {
    return 'CarouselComponent';
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.itemsComponent = this.$component.querySelector(this.SELECTORS.itemsContainer);
    this.trackingComponent = new TrackingComponent();
    this.wishlistLogic = new WishlistLogic();
  }

  determineSlidesValue(carousel) {
    return carousel.classList.contains('--title-top') ? 4.5 : 3.5;
  }

  initCarousel(carouselContainer, slides) {

    const productCards = carouselContainer.querySelectorAll('.carousel__item');
    const carouselWrapper = carouselContainer.closest('.carousel__wrapper');
    const nextArrow = carouselWrapper.querySelector(this.SELECTORS.nextArrow);
    const prevArrow = carouselWrapper.querySelector(this.SELECTORS.prevArrow);

    const showArrows = productCards.length > (carouselContainer.closest('.carousel').classList.contains('--title-top') ? 4 : 3);

    if (showArrows) {
      nextArrow.style.display = 'block';
      prevArrow.style.display = 'block';
    } else {
      nextArrow.style.display = 'none';
      prevArrow.style.display = 'none';
    }

    const options = {
      arrows: showArrows,
      autoplay: false,
      slidesToShow: slides,
      infinite: false,
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            centerPadding: '76.25px',
            slidesToShow: 2,
            initialSlide: 1, // first card to the left, last card hidden from viewport
            centerMode: true,
            infinite: false
          }
        },
        {
          breakpoint: 768,
          arrows: false,
          settings: {
            centerPadding: '86px',
            slidesToShow: 1,
            centerMode: true,
            infinite: true
          }
        }
      ]
    };
    $(carouselContainer).slick(options);
  }

  importSlick(items) {
    this.moduleLoader.loadCarouselAndExecute(
      module => {
        if (items) {
          const slides = this.determineSlidesValue(this.$component.querySelector('.carousel'));
          this.initCarousel(items, slides);
          this.handleWishlist(items, slides);
          this.$emit(this.$customEvents.CAROUSEL.carouselLoaded, {carousel: this.$component});
        } else {
          console.error('Container degli items non trovato.');
        }
      },
      error => {
        console.error("failed to load slick ", error.stack);
      }
    );
  }

  // handle click on wishlist button
  handleWishlist(cardArray) {
    const wishlistButtons = cardArray.querySelectorAll(this.SELECTORS.wishlistButton);
    if (wishlistButtons) {
      wishlistButtons.forEach(btn => {
        const addUrl = btn.dataset.addUrl;
        const removeUrl = btn.dataset.removeUrl;
        const productCode = btn.dataset.code;
        const addedMessage = btn.dataset.addedMessage;
        const removedMessage = btn.dataset.removedMessage;
        const code = btn.dataset.code;
        btn.addEventListener("click", () => {
          event.stopPropagation();
          const isAdding = btn.dataset.jsWishlist === "empty";
          const url = (isAdding ? addUrl : removeUrl) + code;
          fetch(url, { method: 'POST' })
            .then(response => {
              return response.json();
            })
            .then(text => {
              if (isAdding) {
                btn.dataset.jsWishlist = "full";
                this.$emit(this.$customEvents.PRODUCT_EVENTS.addedtowish, { qty: text, elem: btn, msg: addedMessage });
                this.trackingComponent.trackAction('wishlistAdd', {code: productCode});
              } else {
                btn.dataset.jsWishlist = "empty";
                this.$emit(this.$customEvents.PRODUCT_EVENTS.removedfromwish, { qty: text.count, elem: btn, msg: removedMessage });
              }
            })
            .catch(error => this.warn(error));
        });
      });
    }
  }

  render() {
    super.render();
    if (this.itemsComponent.dataset.editMode == "false") {
      this.importSlick(this.itemsComponent);
      this.wishlistLogic.render();
    }
  }
}
